export default __webpack_public_path__ + "static/media/calculator_disc.a2824a5a.png";